export const ru = {
  app: {
    title: 'SportPark',
    tagline: 'Единая операционная система клуба',
  },
  common: {
    save: 'Сохранить',
    cancel: 'Отмена',
    close: 'Закрыть',
    confirm: 'Подтвердить',
    delete: 'Удалить',
    edit: 'Редактировать',
    create: 'Создать',
    search: 'Поиск',
    filters: 'Фильтры',
    export: 'Экспорт',
    import: 'Импорт',
    more: 'Ещё',
    loading: 'Загрузка…',
    offline: 'Нет подключения к серверу',
    back: 'Назад',
    next: 'Далее',
    today: 'Сегодня',
    yes: 'Да',
    no: 'Нет',
    retry: 'Повторить',
    undo: 'Отменить',
    copy: 'Скопировать',
    copied: 'Скопировано',
    emptyValue: '—',
  },
  states: {
    loading: 'Загружаем данные…',
    emptyTitle: 'Пока пусто',
    emptyHint: 'Здесь появится информация, как только она будет доступна',
    errorTitle: 'Что-то пошло не так',
    errorHint: 'Попробуйте обновить страницу или повторите действие',
    forbiddenTitle: 'Доступ запрещён',
    forbiddenHint: 'У вас нет прав для просмотра этого раздела',
  },
  nav: {
    settings: 'Настройки',
    collapse: 'Свернуть',
    expand: 'Развернуть',
  },
  topbar: {
    commandPlaceholder: 'Поиск клиентов, броней, действий…',
    commandShortcut: '⌘K',
    notifications: 'Уведомления',
    notificationsEmpty: 'Новых уведомлений нет',
    notificationsMarkAllRead: 'Прочитать все',
    notificationsError: 'Не удалось загрузить',
    profile: 'Профиль',
    signOut: 'Выйти',
    switchTenant: 'Сменить клуб',
    help: 'Справка',
    shortcuts: 'Горячие клавиши',
    theme: {
      label: 'Тема',
      light: 'Светлая',
      dark: 'Тёмная',
      system: 'Системная',
    },
  },
  auth: {
    welcomeTitle: 'SportPark',
    welcomeSubtitle: 'Единая операционная система клуба',
    chooseMethod: 'Выберите способ входа',
    loginEmail: 'Войти по паролю',
    emailLabel: 'Почта или телефон',
    loginHint: 'Сотрудник входит паролем и кодом из SMS',
    passwordLabel: 'Пароль',
    rememberMe: 'Запомнить меня',
    forgotPassword: 'Забыли пароль или его нет?',
    submit: 'Войти',
    errorInvalidCredentials: 'Неверный логин или пароль. Если пароля ещё нет или он забыт — задайте его кодом из SMS по ссылке выше.',
    errorGeneric: 'Не удалось войти, повторите попытку',
    noAccountHint: 'Нет аккаунта? Обратитесь к администратору клуба',
    showPassword: 'Показать пароль',
    hidePassword: 'Скрыть пароль',
    otp: {
      title: 'Вход по телефону',
      subtitle: 'Отправим одноразовый код в SMS',
      phoneLabel: 'Номер телефона',
      phoneHint: 'Формат: +7 ___ ___-__-__',
      sendCode: 'Отправить код',
      enterCode: 'Код отправлен на {phone}',
      verify: 'Подтвердить',
      resendIn: 'Отправить повторно через 0:{seconds}',
      resend: 'Отправить код повторно',
      errorInvalidCode: 'Неверный код',
      errorExpired: 'Код истёк, запросите новый',
      codeTitle: 'Код из SMS',
      codeTitleEmail: 'Код из письма',
      codeLabel: 'Код',
      sentToLastDigits: 'Пароль верный. Код отправлен на номер, который оканчивается на {digits}.',
      sentToEmail: 'Пароль верный. Код отправлен письмом на почту {hint}.',
      back: 'Изменить логин или пароль',
      errorTooManyAttempts: 'Слишком много попыток. Войдите заново — придёт новый код.',
    },
    forgot: {
      title: 'Пароль по коду из SMS',
      subtitle: 'Код придёт на телефон вашей учётной записи',
      loginLabel: 'Почта или телефон',
      sendCode: 'Получить код',
      whereIsTheCode:
        'Код придёт, если номер подтверждён. Если кода нет — обратитесь к администратору клуба.',
      codeLabel: 'Код из SMS',
      newPasswordLabel: 'Новый пароль',
      passwordRule: 'Не короче 12 символов: цифра, строчная и заглавная буквы.',
      save: 'Сохранить пароль',
      done: 'Пароль задан. Войдите с новым паролем — прежний больше не действует нигде.',
      toLogin: 'Ко входу',
      errorInvalidCode: 'Неверный или устаревший код. Запросите новый.',
      errorGeneric: 'Не удалось задать пароль, повторите попытку',
    },
    tenant: {
      title: 'Выберите клуб',
      subtitle: 'Ваш аккаунт связан с несколькими клубами',
      roleOwner: 'Владелец',
      roleManager: 'Менеджер',
      roleReceptionist: 'Администратор',
      roleTrainer: 'Тренер',
      empty: 'Ни один клуб не связан с вашим аккаунтом',
      emptyHint: 'Попросите администратора клуба добавить вас — вход появится сразу после этого.',
      failed: 'Не удалось загрузить список клубов',
      failedHint: 'Это сбой связи, а не отсутствие доступа.',
      retry: 'Повторить',
    },
  },
  dashboard: {
    title: 'Главная панель',
    deskTitle: 'Смена',
    customize: 'Настроить виджеты',
    fullscreen: 'Полный экран',
    fullscreenExit: 'Выйти из полного экрана',
    kpi: {
      revenue: 'Выручка',
      bookings: 'Бронирования',
      utilization: 'Загрузка кортов',
      activeClients: 'Активные клиенты',
      deltaVsPrevPeriod: 'vs прошлый период',
      refunded: 'возвраты',
      cancelled: 'отменено',
      bonusPaid: 'бонусами',
    },
    revenueTrend: 'Тренд выручки',
    revenueRange7d: '7 дней',
    revenueRange30d: '30 дней',
    revenueRange90d: '90 дней',
    attentionTitle: 'Требует внимания',
    activityTitle: 'Лента активности',
    utilizationTitle: 'Загрузка по кортам',
    emptyTitle: 'Данные появятся с первыми бронированиями',
    emptyCta: 'Перейти к расписанию',
    widgets: {
      kpi_strip: 'Ключевые показатели',
      revenue_trend: 'Выручка и тренд',
      action_center: 'Центр внимания',
      activity_feed: 'Лента активности',
      live_court_occupancy: 'Загрузка кортов',
      deposit_balances: 'Авансовые счета клиентов',
      bonus_balances: 'Бонусы клиентов',
      payments_today: 'Оплаты сегодня',
      refunds_today: 'Возвраты сегодня',
      task_messenger: 'Задачи',
      live_checkin: 'Живой чек-ин',
      client_calls: 'Вызовы администратора',
      upcoming_visits: 'Ближайшие визиты',
      inbox_queues: 'Обращения',
      occupancy_heatmap: 'Тепловая карта загрузки',
      trainer_leaderboard: 'Рейтинг тренеров',
    },
    categories: {
      operations: 'Операции',
      finance_analytics: 'Финансы и аналитика',
      trainer: 'Тренер',
    },
    size: {
      S: 'Узкий',
      M: 'Средний',
      L: 'Широкий',
    },
    edit: {
      title: 'Настройка виджетов',
      hint: 'Перетащите карточки, меняйте размер или добавьте новые.',
      remove: 'Убрать виджет',
      reset: 'Сбросить',
      done: 'Готово',
      allPlaced: 'Все доступные виджеты уже на дашборде.',
      saving: 'Сохранение…',
      saved: 'Сохранено',
      saveError: 'Не сохранено',
    },
    empty: {
      title: 'Дашборд пуст',
      hint: 'Добавьте виджеты, чтобы собрать панель под себя.',
      cta: 'Добавить виджеты',
      noneTitle: 'Виджеты появятся позже',
      noneHint: 'Для вашей роли виджеты дашборда добавятся в следующих обновлениях.',
    },
    tasks: {
      inbox: 'Мои задачи',
      outbox: 'Поставленные',
      assign: 'Поставить задачу',
      pickAssignee: 'Выберите сотрудника',
      textPlaceholder: 'Что нужно сделать?',
      priorityLow: 'Низкий',
      priorityNormal: 'Обычный',
      priorityHigh: 'Высокий',
      send: 'Отправить',
      markDone: 'Выполнено',
      from: 'от {name}',
      to: 'кому: {name}',
      emptyInbox: 'Новых задач нет.',
      emptyOutbox: 'Вы пока не ставили задач.',
    },
    checkin: {
      waiting: 'Ожидание проходов через турникет…',
      in: 'Вход',
      out: 'Выход',
      zone: 'Зона',
      denied: 'Доступ запрещён',
      debt: 'Долг',
      blacklist: 'Чёрный список',
    },
    calls: {
      empty: 'Активных вызовов нет.',
      needHelp: 'Нужна помощь',
      accept: 'Принял',
      resolve: 'Решено',
      acceptedBy: 'Принял: {name}',
    },
    visits: {
      empty: 'Ближайших визитов нет.',
      loadError: 'Не удалось загрузить визиты',
      staleError: 'Не удалось обновить визиты — показаны прежние',
      toSchedule: 'В шахматку',
      live: 'идёт сейчас',
      held: 'идёт оплата',
      holdUntil: 'оплата до {time}',
      status: {
        reserved: 'ожидает оплаты',
        paid: 'оплачено',
        confirmed: 'подтверждено',
      },
    },
    inbox: {
      chat: 'Чат',
      chatHint: 'непрочитанных',
      calls: 'Вызовы',
      callsHint: 'ждут администратора',
      callsAccepted: 'принято: {count}',
      reports: 'Жалобы',
      reportsHint: 'открытых',
      tasks: 'Мои задачи',
      tasksHint: 'не выполнено',
      loadError: 'Не удалось загрузить',
      stale: 'Не удалось обновить — число прежнее',
      retry: 'Повторить',
    },
  },
  roles: {
    SuperAdmin: 'Суперадмин',
    ClubOwner: 'Владелец',
    Manager: 'Менеджер',
    Receptionist: 'Администратор',
    Trainer: 'Тренер',
  },
  toast: {
    saved: 'Сохранено',
    deleted: 'Удалено',
    error: 'Ошибка',
    networkError: 'Нет связи с сервером',
    copiedToClipboard: 'Скопировано в буфер',
  },
  shortcuts: {
    dialogTitle: 'Горячие клавиши',
    global: 'Глобальные',
    search: 'Поиск',
    navigation: 'Навигация',
    openPalette: 'Открыть командную палитру',
    focusSearch: 'Сфокусироваться на поиске',
    newBooking: 'Новая бронь',
    refreshData: 'Обновить данные',
    showShortcuts: 'Показать горячие клавиши',
    toggleTheme: 'Переключить тему',
    signOut: 'Выйти из системы',
  },
  palette: {
    placeholder: 'Что хотите сделать? Поиск клиентов, броней, команд…',
    sectionRecent: 'Недавнее',
    sectionActions: 'Действия',
    sectionNavigation: 'Навигация',
    sectionClients: 'Клиенты',
    sectionBookings: 'Бронирования',
    sectionSettings: 'Настройки',
    empty: 'Ничего не найдено',
    navigateHint: '↑↓ — выбор',
    selectHint: '↵ — выполнить',
    closeHint: 'esc — закрыть',
  },
} as const;
